import React, { Component, PureComponent } from "react";
import {
  Text,
  View,
  ScrollView,
  Image,
  TouchableOpacity,
  SafeAreaView,
  StatusBar,
  ActivityIndicator,
  Platform,
  Alert,
  Dimensions,
} from "react-native";
import * as Font from "expo-font";
import { LinearGradient } from "expo-linear-gradient";
import { Feather } from "@expo/vector-icons";
import { SvgCss } from "react-native-svg";
import firebase from "firebase";
import "firebase/firestore";
import CachedImage from "../../shared/CachedImage";
import * as Find from "../../Home/Find/findFunctions"


import data from "./imageData";
import ProductPreview from "./shared/ProductPreview";
import CommunityPreview from "./shared/CommunityPreview";
import ShopPreview from "./shared/ShopPreview";
import { SmallOffers } from "./OfferResultScreen"

const SCREEN_HEIGHT = Dimensions.get("window").height;
const SCREEN_WIDTH = Dimensions.get("window").width;

// const images = {
//   Topbackground: require("../../images/acComponent/Rectangle3.png")
// };

const firstRow = [
  {
    id: 1,
    // image: require("../../images/acComponent/mobilePhones3.png"),

    image: {
      uri: data.images["Men´s Clothes"],
    },

    Text: "Men´s Clothes",
  },
  {
    id: 2,
    // image: require("../../images/acComponent/acComponent3.png"),
    image: {
      uri: data.images["Women´s Clothes"],
    },
    Text: "Women´s Clothes",
  },
  {
    id: 3,
    // image: require("../../images/acComponent/generator3.png"),
    image: {
      uri: data.images["Children's Clothes"],
    },
    Text: "Children's Clothes",
  },
  {
    id: 4,
    // image: require("../../images/acComponent/Computers.png"),
    image: {
      uri: data.images["Bags"],
    },
    Text: "Bags",
  },
  {
    id: 5,
    // image: require("../../images/acComponent/Tv.png"),
    image: {
      uri: data.images["Shoes"],
    },
    Text: "Shoes",
  },
  {
    id: 6,
    // image: require("../../images/acComponent/Speaker.png"),
    image: {
      uri: data.images["Watches"],
    },
    Text: "Watches",
  },
  {
    id: 7,
    // image: require("../../images/acComponent/HeadPhone.png"),
    image: {
      uri: data.images["Accessories"],
    },
    Text: "Accessories",
  },
  {
    id: 8,
    // image: require("../../images/acComponent/HeadPhone.png"),
    image: {
      uri: data.images["Appliances"],
    },
    Text: "Appliances",
  },
];

// const SecondRow = [
//   {
//     id: 1,
//     image: require("../../images/acComponent/newHeadPhone.png"),
//     Text: "Black and Gold Headphone",
//     price: "N5,000"
//   },
//   {
//     id: 2,
//     image: require("../../images/acComponent/macbookpro.png"),
//     Text: "Brand New 2015 Macbook Pro",
//     price: "N300,000"
//   },
//   {
//     id: 3,
//     image: require("../../images/acComponent/speakers.png"),
//     Text: "ASUS  Computer   Speaker",
//     price: "N12,000"
//   },
//   {
//     id: 4,
//     image: require("../../images/acComponent/iphone6.png"),
//     Text: "iPhone 6s Plus",
//     price: "N120,000"
//   }
// ];

// const thirdRow = [
//   {
//     id: 1,
//     image: require("../../images/acComponent/mobilePhones3.png"),
//     Text: "Phones",
//     price: "N350,000"
//   },
//   {
//     id: 2,
//     image: require("../../images/acComponent/acComponent3.png"),
//     Text: "Air conditions",
//     price: "N50,000"
//   },
//   {
//     id: 3,
//     image: require("../../images/acComponent/generator3.png"),
//     Text: "Genarators",
//     price: "N300,000"
//   },
//   {
//     id: 4,
//     image: require("../../images/acComponent/Computers.png"),
//     Text: "Computers",
//     price: "N350,000"
//   },
//   {
//     id: 5,
//     image: require("../../images/acComponent/Tv.png"),
//     Text: "Televisions",
//     price: "N100,000"
//   },
//   {
//     id: 6,
//     image: require("../../images/acComponent/Speaker.png"),
//     Text: "Speakers",
//     price: "N13,000"
//   },
//   {
//     id: 7,
//     image: require("../../images/acComponent/HeadPhone.png"),
//     Text: "HeadPhones",
//     price: "N13,000"
//   },
//   {
//     id: 8,
//     image: require("../../images/acComponent/macbookpro.png"),
//     Text: "Brand New 2015 Macbook Pro",
//     price: "N300,000"
//   }
// ];
const chatGroups = [
  {
    id: 1,
    tile: "Ikeja Phone Sellers Group",
    Text:
      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna",
  },
  {
    id: 2,
    tile: "Ikeja Laptop Sellers Group",
    Text:
      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna",
  },
  {
    id: 3,
    tile: "Ikeja Phone Sellers Group",
    Text:
      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna",
  },
];
const categories = [
  { id: 1, text: " Refrigerator |" },
  { id: 2, text: "Generator | " },
  { id: 3, text: "Hard Drives |" },
  { id: 4, text: "Fan |" },
  { id: 5, text: "Digital Camera |" },
  { id: 6, text: "Mouse | " },
  { id: 7, text: "Keyboard |" },
  { id: 8, text: "Blender |" },
  { id: 9, text: "Microwave |" },
  { id: 10, text: "Electric Kettle |" },
  { id: 11, text: "Pressing Iron" },
];

const moreIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 65 65"><defs><style>.a{fill:#4160e0;}.b{fill:#fff;}</style></defs><rect class="a" width="65" height="65" rx="12"/><path class="b" d="M20.813,9.563A2.813,2.813,0,1,0,18,12.375,2.821,2.821,0,0,0,20.813,9.563Zm0,16.875A2.813,2.813,0,1,0,18,29.25,2.821,2.821,0,0,0,20.813,26.438Zm0-8.437A2.813,2.813,0,1,0,18,20.813,2.821,2.821,0,0,0,20.813,18Z" transform="translate(14.875 14.5)"/></svg>`;
const pencilIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="77.849" height="77.849" viewBox="0 0 77.849 77.849"><defs><style>.a{fill:#f4f1f1;}.b{fill:#e7dfdd;}.c{fill:#38336b;}.d{fill:#90d960;}.e{fill:#ffda2c;}.f{fill:#febf00;}.g{fill:#d20041;}.h{fill:#ba003a;}</style></defs><path class="a" d="M425.522,372.708l-2.658-7.342H412.97l-2.657,7.342a2.281,2.281,0,0,0,.072,1.728l5.46,11.9a2.281,2.281,0,0,0,4.146,0l5.46-11.9A2.281,2.281,0,0,0,425.522,372.708Z" transform="translate(-347.81 -309.813)"/><path class="b" d="M468.695,372.708l-2.657-7.342H461.09v22.3a2.281,2.281,0,0,0,2.073-1.329l5.46-11.9A2.281,2.281,0,0,0,468.695,372.708Z" transform="translate(-390.982 -309.813)"/><path class="a" d="M55.654,0H2.281A2.281,2.281,0,0,0,0,2.281V75.568a2.281,2.281,0,0,0,2.281,2.281H55.654a2.281,2.281,0,0,0,2.281-2.281V2.281A2.281,2.281,0,0,0,55.654,0Z"/><g transform="translate(28.968)"><path class="b" d="M217.2,0H190.515V77.849H217.2a2.281,2.281,0,0,0,2.281-2.281V2.281A2.281,2.281,0,0,0,217.2,0Z" transform="translate(-190.515)"/></g><g transform="translate(33.929 17.285)"><path class="c" d="M239.908,118.24H225.424a2.281,2.281,0,1,1,0-4.561h14.484a2.281,2.281,0,1,1,0,4.561Z" transform="translate(-223.143 -113.679)"/><g transform="translate(0 13.837)"><path class="c" d="M239.908,209.245H225.424a2.281,2.281,0,1,1,0-4.561h14.484a2.281,2.281,0,1,1,0,4.561Z" transform="translate(-223.143 -204.684)"/></g><g transform="translate(0 27.674)"><path class="c" d="M239.908,300.249H225.424a2.281,2.281,0,1,1,0-4.561h14.484a2.281,2.281,0,1,1,0,4.561Z" transform="translate(-223.143 -295.688)"/></g><g transform="translate(0 42.041)"><path class="c" d="M239.908,394.739H225.424a2.281,2.281,0,1,1,0-4.561h14.484a2.281,2.281,0,1,1,0,4.561Z" transform="translate(-223.143 -390.178)"/></g></g><g transform="translate(7.273 13.08)"><path class="d" d="M53.381,97.516a2.279,2.279,0,0,1-1.613-.668L48.5,93.583a2.281,2.281,0,0,1,3.225-3.225l1.652,1.652L58.7,86.695a2.281,2.281,0,0,1,3.225,3.225l-6.928,6.928A2.28,2.28,0,0,1,53.381,97.516Z" transform="translate(-47.835 -86.026)"/><g transform="translate(0 13.837)"><path class="d" d="M53.381,188.521a2.28,2.28,0,0,1-1.613-.668L48.5,184.588a2.281,2.281,0,0,1,3.225-3.225l1.652,1.652L58.7,177.7a2.281,2.281,0,0,1,3.225,3.225l-6.928,6.928A2.281,2.281,0,0,1,53.381,188.521Z" transform="translate(-47.835 -177.032)"/></g><g transform="translate(0 27.674)"><path class="d" d="M53.381,279.525a2.279,2.279,0,0,1-1.613-.668L48.5,275.592a2.281,2.281,0,0,1,3.225-3.225l1.652,1.652L58.7,268.7a2.281,2.281,0,0,1,3.225,3.225l-6.928,6.928A2.28,2.28,0,0,1,53.381,279.525Z" transform="translate(-47.835 -268.036)"/></g></g><path class="e" d="M425.662,7.741V55.27a2.281,2.281,0,0,1-2.281,2.281h-10.92a2.28,2.28,0,0,1-2.281-2.281V7.741a7.741,7.741,0,0,1,15.482,0Z" transform="translate(-347.813 0)"/><path class="f" d="M461.09,0V57.55h5.46a2.281,2.281,0,0,0,2.281-2.281V7.741A7.75,7.75,0,0,0,461.09,0Z" transform="translate(-390.982)"/><g transform="translate(62.367 14.431)"><path class="g" d="M410.18,94.91h15.482v4.561H410.18Z" transform="translate(-410.18 -94.91)"/></g><path class="h" d="M461.09,94.91h7.741v4.561H461.09Z" transform="translate(-390.982 -80.479)"/></svg>`;

const LikeIcon = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="60" height="60" viewBox="0 0 60 60"><defs><style>.a{fill:#fff;}.b{fill:red;stroke:#707070;}.c{filter:url(#a);}</style><filter id="a" x="0" y="0" width="60" height="60" filterUnits="userSpaceOnUse"><feOffset dy="3" input="SourceAlpha"/><feGaussianBlur stdDeviation="5" result="b"/><feFlood flood-opacity="0.149"/><feComposite operator="in" in2="b"/><feComposite in="SourceGraphic"/></filter></defs><g transform="translate(15 12)"><g class="c" transform="matrix(1, 0, 0, 1, -15, -12)"><rect class="a" width="30" height="30" rx="8" transform="translate(15 12)"/></g><path class="b" d="M6.786,12.075a.8.8,0,0,1-.525-.2c-.548-.479-1.077-.93-1.543-1.327l0,0a28.7,28.7,0,0,1-3.37-3.163A5.052,5.052,0,0,1,0,4.079a4.242,4.242,0,0,1,1.077-2.9A3.65,3.65,0,0,1,3.791,0,3.414,3.414,0,0,1,5.924.736a4.363,4.363,0,0,1,.862.9,4.363,4.363,0,0,1,.862-.9A3.414,3.414,0,0,1,9.78,0,3.65,3.65,0,0,1,12.5,1.182a4.242,4.242,0,0,1,1.077,2.9,5.051,5.051,0,0,1-1.346,3.306,28.7,28.7,0,0,1-3.369,3.163c-.467.4-1,.849-1.546,1.33A.8.8,0,0,1,6.786,12.075ZM3.791.8a2.863,2.863,0,0,0-2.13.925A3.451,3.451,0,0,0,.795,4.079a4.25,4.25,0,0,0,1.163,2.8A28.244,28.244,0,0,0,5.231,9.943l0,0c.468.4,1,.851,1.551,1.334.556-.484,1.087-.937,1.556-1.336a28.249,28.249,0,0,0,3.273-3.065,4.251,4.251,0,0,0,1.163-2.8,3.451,3.451,0,0,0-.866-2.358A2.863,2.863,0,0,0,9.78.8a2.637,2.637,0,0,0-1.646.57,3.858,3.858,0,0,0-.917,1.062.5.5,0,0,1-.862,0,3.854,3.854,0,0,0-.917-1.062A2.637,2.637,0,0,0,3.791.8Zm0,0" transform="translate(8 9)"/></g></svg>`;

let filteredCategory = [];

export default class HomeFashionScreen extends Component {
  static navigationOptions = ({ navigation }) => {
    const category2 = navigation.getParam("category2", "Fashion");
    const hideTitle = navigation.getParam("hideTitle", false);
    return {
      tabBarVisible: false,
      headerTransparent: true,
      title: hideTitle ? "" : category2,
      headerTitleStyle: {
        fontWeight: "bold",
        color: "#333333",
        shadowOpacity: 0.1,
      },
    };
  };

  state = {
    assetsLoaded: false,
    allOffersLoaded: false,
    category2: null,
    showCategory: false,
    promotionProfileID: null,
    promotionImageURL: null,
    promotionBannerComponents: [],
    allOffers: []
  };

  constructor() {
    super();
    const firestore = firebase.firestore();
    this.unsubscribeFirestore = () => {
      return;
    };
  }

  async componentDidMount() {
    this.loadPromotions();

    console.log("my Global category", global.categories.Fashion);
    const globalFashionCategory = global.categories.Fashion;

    const categoryToFilter = firstRow.map((item) => {
      return item.Text;
    });
    filteredCategory = globalFashionCategory.filter(
      (text) => !categoryToFilter.includes(text)
    );

    console.log(filteredCategory);

    console.log(" categories to be mapped", filteredCategory);
    console.log("myGlobal with a new", globalFashionCategory);
    console.log("newfilter", categoryToFilter);

    await Font.loadAsync({
      "ProximaNovaA-Regular": require("../../../assets/font/ProximaNovaA-Regular.ttf"),
      "ProximaNovaA-Bold": require("../../../assets/font/ProximaNovaA-Bold.ttf"),
    });
    const category2 = this.props.navigation.getParam("category2", null);
    this.setState({ category2 });
    console.log("my  fashion category", this.state.category2);

    this.setState({ assetsLoaded: true });
    try {
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 200);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 400);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 500);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 500);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 600);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 1000);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 2000);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 4000);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 5000);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 8000);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 10000);
        });
      if (!global.myUID || !global.myProfileID) await global.setGlobals();
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 10000);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 100000);
        });
      if (!global.myUID || !global.myProfileID) await global.setGlobals();
      if (!global.myUID) return;

      this.loadAllOffers();

    } catch (err) {
      if (global.reportError) {
        global.reportError(err, "catches", "homeFashion");
      }
    }
  }

  loadAllOffers = async () => {
    try {
      const re = await Find.findPostOffersAsync({
        orderBy: "RECENT",
        category1: "Fashion",
        category2: this.props.navigation.getParam("category2") || null,
        location: global.location || { coords: { latitude: 6.6, longitude: 3.3 } },
        amount: 100,
      })
      console.log("ALLOFFERS", re)
      if (re == -1) return this.setState({ allOffersLoaded: true })
      if (re.length == 0) return this.setState({ allOffersLoaded: true })
      if (re.length > 0) this.setState({ allOffers: re, allOffersLoaded: true })

    } catch (e) {
      global.warn(e, "loadAllOffers")
    }
  }

  componentWillUnmount() {
    console.log("Component homeFashion will unmount");
    this.unsubscribeFirestore();
  }

  loadPromotions = async () => {
    try {
      if (!global.myUID)
        await new Promise((resolve) => {
          setTimeout(resolve, 1000);
        });
      if (!global.myUID)
        await new Promise((resolve) => {
          setTimeout(resolve, 2000);
        });
      if (!global.myUID)
        await new Promise((resolve) => {
          setTimeout(resolve, 4000);
        });
      if (!global.myUID)
        await new Promise((resolve) => {
          setTimeout(resolve, 8000);
        });
      const promotionsDoc = await firebase
        .firestore()
        .collection("ServerClientReadOnly")
        .doc("promotions")
        .get();
      const promotions = promotionsDoc.data();
      const banners =
        global.myLocalCurrency == "GHS"
          ? promotions.ghBannersFashion
          : promotions.topBannersFashion;
      const newPromotions = banners.map((item) => {
        item.randomValue = Math.random();
        return item;
      });
      newPromotions.sort((a, b) => {
        return b.randomValue - a.randomValue;
      });

      this.setState({
        // promotionProfileID: promotions.topBannersFashion[0].profileID,
        // promotionImageURL: promotions.topBannersFashion[0].imageURL,
        promotionBannerComponents: newPromotions,
      });
      console.log(
        " fashionstate banner components"
        // promotions.topBannersFashion[0].profileID,
        // promotions.topBannersFashion[0].imageURL,
        //promotions.topBannersFashion
      );
    } catch (err) {
      console.log("Error initiating database connection (Search-CC)", err);
    }
  };
  toggleCategory() {
    this.setState({
      showCategory: !this.state.showCategory,
    });
    console.log("toggle button handler: " + this.state.showCategory);
  }
  render() {
    console.log("my image", data.images["Phones"]);
    if (this.state.assetsLoaded) {
      console.log("loaded");
      return (
        <ScrollView
          onScroll={(e) => {
            try {
              // if (e.nativeEvent.contentOffset.y >= 55)
              //   this.props.navigation.setParams({ hideTitle: true });
              // else this.props.navigation.setParams({ hideTitle: false });
            } catch (e) {
              console.warn("caught setParam/onScroll error");
              console.log("onScroll error", e);
            }
          }}
          scrollEventThrottle={1000}
        >
          <LinearGradient
            colors={[
              "#AF2ABA",
              "#F5F5F5",
              "#F5F5F5",
              "#F5F5F5",
              "#F5F5F5",
              "#F5F5F5",
              "#F5F5F5",
              "#F5F5F5",
              "#F5F5F5",
            ]}
            style={{
              flex: 1,
              position: "absolute",
              left: 0,
              right: 0,
              top: 0,
              height: "100%",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          />
          {/* <SafeAreaView
            style={{
              flex: 1

              // backgroundColor: global.app == "health" ? "#fff" : "#131313"
            }}
          > */}
          <StatusBar barStyle="light-content" />

          <View
            style={{
              backgroundColor: "F5F5F5",
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <View
              style={{
                backgroundColor: "F5F5F5",
                borderBottomColor: "#555",
                alignItems: "center",
                justifyContent: "center",

                // borderBottomWidth: 1,
                ...Platform.select({
                  ios: {
                    height: Dimensions.get("window").height >= 800 ? 88 : 65,
                  },
                  android: { height: 85 },
                }),
              }}
            />

            <ScrollView
              horizontal={true}
              pagingEnabled={true}
              showsHorizontalScrollIndicator={false}
            >
              {this.state.promotionBannerComponents.map((item) => {
                return (
                  <TouchableOpacity
                    key={item.profileID || item.url}
                    onPress={() => {
                      if (item.url) {
                        Linking.openURL(item.url);
                      } else if (item.profileID) {
                        let handoverID = item.profileID;
                        this.props.navigation.navigate("meProfile", {
                          profileID: handoverID,
                        });
                      }
                      global.reportStats(
                        "pressed_Fashion_Banner",
                        item.profileID || item.url,
                        item.imageURL
                      );
                    }}
                    style={{ padding: 5, margin: 5 }}
                  >
                    {item.imageURL && (
                      <CachedImage
                        key={item.imageURL}
                        style={{
                          width: SCREEN_WIDTH * 0.95,
                          height: SCREEN_HEIGHT * 0.25,
                          bottom: 28,
                        }}
                        source={{
                          uri: item.imageURL,
                        }}
                        resizeMode="contain"
                      />
                    )}
                  </TouchableOpacity>
                );
              })}
            </ScrollView>
            {this.state.promotionBannerComponents.length == 0 && (
              <View style={{ height: 75 }} />
            )}

            {!this.state.category2 && (
              <View
                style={{
                  width: 340,
                  justifyContent: "center",
                  marginHorizontal: 10,
                  // marginTop: 10,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginLeft: 12,
                    flexWrap: "wrap",
                    bottom: 50,
                    alignItems: "center",
                  }}
                >
                  {firstRow.map((item) => {
                    return (
                      <TouchableOpacity
                        key={item.id}
                        style={{
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          marginBottom: 25,
                        }}
                        onPress={() => {
                          this.props.navigation.navigate({
                            routeName: "homeFashion",
                            params: { category2: item.Text },
                            key: item,
                          });
                          global.reportStats(
                            "pressed_Fashion_Category2",
                            item.Text
                          );
                        }}
                      >
                        <CachedImage
                          style={{
                            width: 70,
                            height: 70,
                            borderRadius: 12,
                            borderColor: "black",
                            borderWidth: 0.05,
                            shadowColor: "#000",
                            shadowOpacity: 0.3,
                            marginBottom: 20,
                          }}
                          source={item.image}
                          resizeMode="cover"
                        />

                        <View
                          style={{
                            maxWidth: 65,

                            maxHeight: 32,
                            position: "absolute",
                            top: 75,
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: "ProximaNovaA-Regular",
                              color: "#333333",
                              // marginTop: 10,
                              // flexWrap: "wrap"
                            }}
                          >
                            {item.Text}
                          </Text>
                        </View>
                      </TouchableOpacity>
                    );
                  })}
                </View>
              </View>
            )}

            {this.state.showCategory ? (
              <View
                style={{
                  flexDirection: "column",
                  alignItems: "flex-end",
                  justifyContent: "space-between",
                }}
              >
                <View
                  style={{
                    bottom: 50,
                    right: 18,
                    left: -28,
                  }}
                >
                  <TouchableOpacity
                    onPress={() => {
                      this.toggleCategory();
                    }}
                    style={{
                      margin: 7,
                      padding: 7,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: "ProximaNovaA-Bold",
                        color: "#F46E56",
                      }}
                    >
                      See less
                    </Text>
                  </TouchableOpacity>
                </View>
                <View
                  style={{
                    backgroundColor: "#FFFFFF",
                    minHeight: SCREEN_HEIGHT * 0.2,
                    width: SCREEN_WIDTH * 0.9,
                    borderRadius: 12,
                    alignItems: "center",
                    margin: 12,
                    shadowColor: "#000",
                    shadowOpacity: 0.05,
                    bottom: 50,
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-around",
                      top: 7,
                      flexWrap: "wrap",

                      alignItems: "center",
                    }}
                  >
                    {filteredCategory.map((item) => {
                      return (
                        <TouchableOpacity
                          style={{ margin: 20, padiding: 5 }}
                          key={item}
                          onPress={() => {
                            this.props.navigation.navigate({
                              routeName: "homeFashion",
                              params: { category2: item },
                              key: item,
                            });
                            global.reportStats(
                              "pressed_Fashion_Category2",
                              item
                            );
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: "ProximaNovaA-Regular",
                              color: "#333333",
                            }}
                          >
                            {item}
                          </Text>
                        </TouchableOpacity>
                      );
                    })}
                  </View>
                </View>
              </View>
            ) : (
              <View
                style={{
                  width: "90%",
                  justifyContent: "center",
                  alignItems: "flex-end",
                  bottom: 55,
                  right: 20,
                }}
              >
                {!this.state.category2 && (
                  <TouchableOpacity
                    onPress={() => {
                      this.toggleCategory();
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: "ProximaNovaA-Bold",
                        color: "#4160E0",
                      }}
                    >
                      See More
                    </Text>
                  </TouchableOpacity>
                )}
              </View>
            )}

            <ProductPreview
              searchTerm={this.state.category2 || "Fashion"}
              navigation={this.props.navigation}
            />

            <ShopPreview
              providerCategory1={"Fashion"}
              providerCategory2={this.state.category2}
              navigation={this.props.navigation}
              description="Shops near you"
              fontSize={12}
            />

            {/* <TouchableOpacity
              onPress={() => {
                this.props.navigation.navigate("homeProviderResults", {
                  category1: "Fashion",
                  category2: this.state.category2
                });
              }}
              style={{
                backgroundColor: "#00A85A",
                height: 50,
                width: 330,
                borderRadius: 12,
                alignItems: "center",
                justifyContent: "center",
                shadowColor: "#000",
                shadowOpacity: 0.1,
                alignSelf: "center",
                bottom: 50
              }}
            >
              <Text
                style={{
                  fontFamily: "ProximaNovaA-Bold",
                  fontSize: 12,
                  color: "#FFFFFF"
                }}
              >
                Shops Near you
              </Text>
            </TouchableOpacity> */}

            <View>
              <TouchableOpacity
                onPress={() => {
                  this.props.navigation.navigate("homeSpecialRequest", {
                    category1: "Fashion",
                    category2: this.state.category2,
                  });
                  global.reportStats("pressed_Fashion_SpecialRequest");
                }}
                style={{
                  backgroundColor: "#00A85A",
                  height: 100,
                  width: "85%",
                  margin: 22,
                  borderRadius: 12,
                  alignItems: "center",
                  shadowColor: "#000",
                  shadowOpacity: 0.05,
                  flexDirection: "row",
                  justifyContent: "space-around",
                  bottom: 50,
                }}
              >
                <View style={{ marginLeft: 20 }}>
                  <View style={{ width: 146 }}>
                    <Text
                      style={{
                        fontFamily: "ProximaNovaA-Bold",
                        fontSize: 14,
                        color: "#FFFFFF",
                      }}
                    >
                      Send Special Request
                    </Text>
                  </View>

                  <View style={{ width: 190 }}>
                    <Text
                      style={{
                        fontFamily: "ProximaNovaA-Regular",
                        fontSize: 12,
                        color: "#FFFFFF",
                      }}
                    >
                      Ask 20 sellers near you whether they have what you looking
                      for
                    </Text>
                  </View>
                </View>

                <View style={{ marginRight: 20 }}>
                  <SvgCss xml={pencilIcon} />
                </View>
              </TouchableOpacity>
            </View>

            {/* <View
              style={{
                backgroundColor: "#FFFFFF",
                height: 300,
                width: 330,
                borderRadius: 12,
                alignItems: "center",
                justifyContent: "center",
                // margin: 22,
                alignSelf: "center",
                shadowColor: "#000",
                shadowOpacity: 0.05,
                bottom: 50
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  top: 10
                }}
              >
                <Text
                  style={{
                    right: 70,
                    bottom: 10,
                    fontSize: 12,
                    fontFamily: "ProximaNovaA-Bold",
                    color: "#333333"
                  }}
                >
                  Most Searched Products
                </Text>
                <TouchableOpacity style={{ left: 59, bottom: 10 }}>
                  <Text
                    style={{
                      fontSize: 10,
                      fontFamily: "ProximaNovaA-Regular",
                      color: "#707070"
                    }}
                  >
                    See All
                  </Text>
                </TouchableOpacity>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  flexWrap: "wrap",
                  justifyContent: "space-around",
                  top: 15
                }}
              >
                {thirdRow.map(item => {
                  return (
                    <View
                      key={item.id}
                      style={{
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: 25
                      }}
                    >
                      <Image
                        style={{
                          width: 70,
                          height: 70,
                          borderRadius: 12,

                          shadowColor: "#000",
                          shadowOpacity: 0.5
                        }}
                        source={item.image}
                        resizeMode="contain"
                      />

                      <Text
                        style={{
                          fontSize: 12,
                          fontFamily: "ProximaNovaA-Regular",
                          color: "#333333",
                          marginTop: 10
                        }}
                      >
                        {item.price}
                      </Text>
                    </View>
                  );
                })} 
              </View>
            </View> */}

            <CommunityPreview
              communityCategory={this.state.category2 || "Fashion"}
              navigation={this.props.navigation}
            />

            {!this.state.allOffersLoaded ?
              <View style={{ alignItems: "center", width: global.SWIDTH }}>
                <ActivityIndicator style={{ color: "gray" }} />
              </View>
              : <SmallOffers offers={this.state.allOffers} navigation={this.props.navigation} />}

          </View>
        </ScrollView>
      );
    } else {
      return (
        <View style={styles.container}>
          <ActivityIndicator />
          <StatusBar barStyle="default" />
        </View>
      );
    }
  }
}
